import React from 'react';
import { helpClass, labelClass } from '../ui';

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return <label className="mb-3 block last:mb-0"><span className={labelClass}>{label}</span>{children}</label>;
}
export function SectionTitle({ title, description, action }: { title: string; description: string; action?: React.ReactNode }) {
  return <div className="mb-3 flex items-start justify-between gap-3"><div><h3 className="text-[13px] font-semibold text-slate-800">{title}</h3><p className={helpClass}>{description}</p></div>{action}</div>;
}
export function Empty({ text }: { text: string }) {
  return <div className="rounded-lg border border-dashed border-slate-200 bg-slate-50 px-3 py-2.5 text-[11px] text-slate-400">{text}</div>;
}
